export const LEAVE = 'Leave';
export const RETURN = 'Return';
export const BOTH = 'Both';
